import { useState } from 'react';
// import sgMail from '@sendgrid/mail';
import { useForm } from '@formcarry/react';
import { buttonColor, myBG } from './constants';

const ContactForm = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [anonymous, setAnonymous] = useState(false);

  // server side code
  // const sgMail = require('@sendgrid/mail');
  //   let sgMail;
  //   useEffect(() => {
  //     import('@sendgrid/mail')
  //       .then((module) => {
  //         sgMail = module.default;
  //       })
  //       .catch((error) => {
  //         // Handle the error
  //         console.error('Failed to import @sendgrid/mail:', error);
  //       });
  //   }, []);

  //   sgMail.setApiKey(

  //   );

  //   const sendEmail = async (emailDetails) => {
  //     const { name, from, subject, message, anonymous } = emailDetails;

  //     const msg = {
  //       to: 'gunasekaran.v@northeastern.edu', // Your email address
  //       from: anonymous ? 'Anonymous' : `${name} <${from}>`,
  //       subject: subject || 'No Subject',
  //       text: message || 'No Message',
  //     };

  //     try {
  //       await sgMail.send(msg);
  //       console.log('Email sent successfully');
  //     } catch (error) {
  //       console.error('Error sending email:', error);
  //     }
  //   };

  // client side code
  // Send email using SendGrid API
  // const sendEmail = async () => {
  //   const data = {
  //     personalizations: [
  //       {
  //         to: [{ email: 'gunasekaran.v@northeastern.edu' }],
  //         subject: subject,
  //       },
  //     ],
  //     from: { email: email, name: name },
  //     content: [{ type: 'text/plain', value: message }],
  //   };

  //   const apiKey = process.env.SENDGRID_API_KEY;

  //   try {
  //     const response = await fetch('https://api.sendgrid.com/v3/mail/send', {
  //       method: 'POST',
  //       headers: {
  //         Authorization: `Bearer ${apiKey}`,
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify(data),
  //     });

  //     if (response.ok) {
  //       // Email sent successfully
  //       console.log('Email sent!');
  //       // Reset form fields
  //       clearFields();
  //     } else {
  //       // Error sending email
  //       console.error('Error sending email:', response.statusText);
  //     }
  //   } catch (error) {
  //     console.error('Error sending email:', error);
  //   }
  // };

  // const handleFormSubmit = (e) => {
  //   e.preventDefault(); // to prevent page from reloading on form submit

  //   const emailDetails = {
  //     name: name,
  //     from: email,
  //     subject: subject,
  //     message: message,
  //     anonymous: anonymous,
  //   };

  //   console.log(emailDetails);

  //   sendEmail(emailDetails);

  //   // Reset form fields
  //   clearFields();
  // };

  const clearFields = () => {
    console.log('Clearing');
    setName('');
    setEmail('');
    setSubject('');
    setMessage('');
    setAnonymous(false);
    document.getElementById('name').disabled = false;
    document.getElementById('email').disabled = false;
  };

  const handleAnonymousChange = () => {
    setAnonymous(!anonymous);

    if (!anonymous) {
      // Clear fields and disable inputs
      setName('');
      setEmail('');
      document.getElementById('name').disabled = true;
      document.getElementById('email').disabled = true;
    } else {
      // Enable inputs
      document.getElementById('name').disabled = false;
      document.getElementById('email').disabled = false;
    }
  };

  const { state, submit } = useForm({
    id: process.env.REACT_APP_FORMCARRY_ID || '8RsnO40XIA',
  });

  // Success message
  if (state.submitted) {
    return <div>Thank you! I received your submission.</div>;
  }

  return (
    // <form action="https://formsubmit.co/gunasekaran.v@northeastern.edu" method="POST" style={styles.formBox}></form>
    // <form onSubmit={handleFormSubmit} style={styles.formBox}>
    <form onSubmit={submit} style={styles.formBox}>
      <div style={styles.groupA}>
        <div style={styles.inputContainer}>
          <label htmlFor='name'>Name:</label>
          <input
            type='text'
            id='name'
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder='What can I call you?'
            style={styles.inputField}
            name='name'
          />
        </div>
        <div style={styles.inputContainer}>
          <label htmlFor='email'>Email:</label>
          <input
            type='text'
            id='email'
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder='How can I reach you?'
            style={styles.inputField}
            name='email'
          />
        </div>
      </div>
      <div style={styles.divider}></div>
      <div style={styles.groupB}>
        <input
          type='checkbox'
          id='anonymous'
          checked={anonymous}
          //   onChange={(e) => setAnonymous(e.target.checked)}
          onChange={handleAnonymousChange}
          name='anonymous'
          // style={styles.checkBox}
        />
        <label htmlFor='anonymous'>Anonymous</label>
      </div>
      <div>
        <label htmlFor='subject'>Subject:</label>
        <input
          type='text'
          id='subject'
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          placeholder='Subject'
          style={styles.inputField}
          name='subject'
        />
      </div>
      <div>
        <label htmlFor='message'>Message:</label>
        <textarea
          id='message'
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder='Type your message'
          style={styles.inputField}
          name='message'
        ></textarea>
      </div>
      <div style={styles.buttonContainer}>
        <button type='button' onClick={clearFields} style={styles.button}>
          Clear
        </button>
        <button type='submit' style={styles.button}>
          Send
        </button>
      </div>
    </form>
  );
};

const styles = {
  formBox: {
    width: '60%',
    border: '1px solid black',
    paddingRight: '10px',
    marginRight: '10px',
    padding: '20px',
    background: 'white',
  },
  groupA: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputContainer: {
    // marginBottom: '20px',
  },
  inputField: {
    width: '100%',
    marginBottom: '5px',
    backgroundColor: '#F0F0F0',
  },
  checkBox: {
    backgroundColor: '#F0F0F0',
  },
  divider: {
    borderTop: '1px solid black',
    margin: '5px 0 5px',
  },
  groupB: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '10px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '20px',
  },
  button: {
    padding: '8px 16px',
    backgroundColor: buttonColor,
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
  },
};

export default ContactForm;
